import React from 'react';
import { render } from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import App from '@/App';

import '../assets/fonts/fontface.css';
import 'katex/dist/katex.min.css';

import getConfig from './Util/Config';

import './config/i18n';
const { sentry = {} } = getConfig();

const { enable, dsn, environment, service } = sentry;
if (enable && dsn) {
  Sentry.init({
    dsn: dsn,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: environment ?? 'staging',
    // eslint-disable-next-line no-undef
    release: `${service ? `${service}_` : ''}${__VERSION__}`,
    ...sentry,
  });
}

render(<App />, document.querySelector('#app'));
